import React from "react";

// import { Box, BoxProps } from "@mui/material";
interface SVGProps extends React.SVGProps<SVGSVGElement> { }

export const BombSvg = (props: SVGProps) => {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 96 96"
      width={"20px"}
      height={"20px"}
      className="svg-icon "
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.405 6.399a14.328 14.328 0 0 1 10.015 4.559h-.003a2.114 2.114 0 0 1-.078 3c-.37.368-.876.599-1.44.599h-.024a2.081 2.081 0 0 1-1.539-.68l-.006-.007a9.964 9.964 0 0 0-7.324-3.194 9.93 9.93 0 0 0-5.945 1.961c3.162 4.2 4.4 9.44.921 12.718l-2.36 2.078-.111-.192c-4.301-6.877-10.38-12.534-17.843-16.442l3.44-3.278c3.518-3.32 8.877-1.6 12.875 1.918a14.132 14.132 0 0 1 9.398-3.04h.024Zm-46.414 83.86c21.535 0 38.991-17.456 38.991-38.99 0-21.536-17.456-38.992-38.991-38.992S0 29.733 0 51.268 17.456 90.26 38.991 90.26Z"
      ></path>
    </svg>
  );
};

export const JewlSvg = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 308 280"
      width="308px"
      height="280px"
      preserveAspectRatio="xMidYMid meet"
      style={{
        width: "100%",
        height: "100%",
        transform: "translate3d(0px, 0px, 0px)",
        contentVisibility: "visible",
      }}
      {...props}
    >
      <defs>
        <clipPath id="__lottie_element_71">
          <rect width="308" height="280" x="0" y="0"></rect>
        </clipPath>
      </defs>
      <g clipPath="url(#__lottie_element_71)">
        <g
          transform="matrix(4,0,0,4,0.579010009765625,0)"
          opacity="1"
          style={{ display: "block" }}
        >
          <g opacity="1" transform="matrix(1,0,0,1,38.30699920654297,35)">
            <path
              fill="rgb(5,29,39)"
              fillOpacity="1"
              d=" M-0.2809999883174896,35 C-0.2809999883174896,35 -0.29600000381469727,35 -0.29600000381469727,35 C-1.0740000009536743,34.99599838256836 -1.815000057220459,34.6619987487793 -2.3340001106262207,34.082000732421875 C-2.3340001106262207,34.082000732421875 -37.606998443603516,-5.380000114440918 -37.606998443603516,-5.380000114440918 C-38.409000396728516,-6.2769999504089355 -38.53499984741211,-7.591000080108643 -37.91899871826172,-8.625 C-37.91899871826172,-8.625 -27.281999588012695,-26.45400047302246 -27.281999588012695,-26.45400047302246 C-26.988000869750977,-26.94700050354004 -26.547000885009766,-27.336000442504883 -26.020000457763672,-27.56599998474121 C-26.020000457763672,-27.56599998474121 -15.1899995803833,-32.29399871826172 -15.1899995803833,-32.29399871826172 C-14.991000175476074,-32.38100051879883 -14.781999588012695,-32.444000244140625 -14.567999839782715,-32.481998443603516 C-14.567999839782715,-32.481998443603516 -0.5709999799728394,-34.95800018310547 -0.5709999799728394,-34.95800018310547 C-0.2529999911785126,-35.013999938964844 0.0729999989271164,-35.013999938964844 0.38999998569488525,-34.95800018310547 C0.38999998569488525,-34.95800018310547 14.312999725341797,-32.481998443603516 14.312999725341797,-32.481998443603516 C14.526000022888184,-32.444000244140625 14.732999801635742,-32.38100051879883 14.930000305175781,-32.29499816894531 C14.930000305175781,-32.29499816894531 26.114999771118164,-27.423999786376953 26.114999771118164,-27.423999786376953 C26.1560001373291,-27.4060001373291 26.197999954223633,-27.386999130249023 26.23900032043457,-27.367000579833984 C26.23900032043457,-27.367000579833984 26.242000579833984,-27.364999771118164 26.242000579833984,-27.364999771118164 C26.242000579833984,-27.364999771118164 26.243999481201172,-27.36400032043457 26.243999481201172,-27.36400032043457 C26.243999481201172,-27.36400032043457 26.2450008392334,-27.36400032043457 26.246000289916992,-27.363000869750977 C26.246000289916992,-27.363000869750977 26.249000549316406,-27.36199951171875 26.249000549316406,-27.36199951171875 C26.249000549316406,-27.36199951171875 26.249000549316406,-27.361000061035156 26.25,-27.361000061035156 C26.492000579833984,-27.240999221801758 26.711999893188477,-27.086999893188477 26.9060001373291,-26.9060001373291 C26.9060001373291,-26.905000686645508 26.9060001373291,-26.905000686645508 26.9060001373291,-26.905000686645508 C26.906999588012695,-26.90399932861328 26.908000946044922,-26.902999877929688 26.909000396728516,-26.902000427246094 C27.059999465942383,-26.760000228881836 27.195999145507812,-26.60099983215332 27.312999725341797,-26.424999237060547 C27.31399917602539,-26.424999237060547 27.31399917602539,-26.423999786376953 27.31399917602539,-26.423999786376953 C27.31399917602539,-26.423999786376953 27.31399917602539,-26.42300033569336 27.31399917602539,-26.42300033569336 C27.344999313354492,-26.378000259399414 27.37299919128418,-26.332000732421875 27.402000427246094,-26.284000396728516 C27.402000427246094,-26.284000396728516 37.926998138427734,-8.402000427246094 37.926998138427734,-8.402000427246094 C38.53900146484375,-7.361000061035156 38.402000427246094,-6.041999816894531 37.58700180053711,-5.14900016784668 C37.58700180053711,-5.14900016784668 1.7519999742507935,34.104000091552734 1.7519999742507935,34.104000091552734 C1.2309999465942383,34.67499923706055 0.492000013589859,35 -0.2809999883174896,35z"
            ></path>
          </g>
          <g opacity="1" transform="matrix(1,0,0,1,38.30699920654297,35)">
            <path
              fill="rgb(86,252,126)"
              fillOpacity="1"
              d=" M25.023000717163086,-24.89699935913086 C25.023000717163086,-24.89699935913086 13.831999778747559,-29.77199935913086 13.831999778747559,-29.77199935913086 C13.831999778747559,-29.77199935913086 -0.09099999815225601,-32.24700164794922 -0.09099999815225601,-32.24700164794922 C-0.09099999815225601,-32.24700164794922 -14.088000297546387,-29.77199935913086 -14.088000297546387,-29.77199935913086 C-14.088000297546387,-29.77199935913086 -24.917999267578125,-25.04400062561035 -24.917999267578125,-25.04400062561035 C-24.917999267578125,-25.04400062561035 -35.55400085449219,-7.215000152587891 -35.55400085449219,-7.215000152587891 C-35.55400085449219,-7.215000152587891 -0.2809999883174896,32.24700164794922 -0.2809999883174896,32.24700164794922 C-0.2809999883174896,32.24700164794922 35.55400085449219,-7.00600004196167 35.55400085449219,-7.00600004196167 C35.55400085449219,-7.00600004196167 25.023000717163086,-24.89699935913086 25.023000717163086,-24.89699935913086z"
            ></path>
          </g>
          <g
            opacity="1"
            transform="matrix(1,0,0,1,30.392000198364258,28.7549991607666)"
          >
            <path
              fill="rgb(6,227,3)"
              fillOpacity="1"
              d=" M-8.263999938964844,-10.008000373840332 C-8.263999938964844,-10.008000373840332 -6.172999858856201,10.008000373840332 -6.172999858856201,10.008000373840332 C-6.172999858856201,10.008000373840332 8.263999938964844,-6.982999801635742 8.263999938964844,-6.982999801635742 C8.263999938964844,-6.982999801635742 -8.263999938964844,-10.008000373840332 -8.263999938964844,-10.008000373840332z"
            ></path>
          </g>
          <g
            opacity="1"
            transform="matrix(1,0,0,1,64.11799621582031,19.048999786376953)"
          >
            <path
              fill="rgb(5,169,2)"
              fillOpacity="1"
              d=" M9.743000030517578,8.944999694824219 C9.743000030517578,8.944999694824219 -0.7879999876022339,-8.944999694824219 -0.7879999876022339,-8.944999694824219 C-0.7879999876022339,-8.944999694824219 -9.743000030517578,-0.041999999433755875 -9.743000030517578,-0.041999999433755875 C-9.743000030517578,-0.041999999433755875 9.743000030517578,8.944999694824219 9.743000030517578,8.944999694824219z"
            ></path>
          </g>
          <g
            opacity="1"
            transform="matrix(1,0,0,1,62.303001403808594,28.743000030517578)"
          >
            <path
              fill="rgb(3,189,2)"
              fillOpacity="1"
              d=" M-11.557999610900879,9.736000061035156 C-11.557999610900879,9.736000061035156 11.557999610900879,-0.7490000128746033 11.557999610900879,-0.7490000128746033 C11.557999610900879,-0.7490000128746033 -7.928999900817871,-9.736000061035156 -7.928999900817871,-9.736000061035156 C-7.928999900817871,-9.736000061035156 -11.557999610900879,9.736000061035156 -11.557999610900879,9.736000061035156z"
            ></path>
          </g>
          <g
            opacity="1"
            transform="matrix(1,0,0,1,46.43199920654297,28.757999420166016)"
          >
            <path
              fill="rgb(1,228,1)"
              fillOpacity="1"
              d=" M-7.941999912261963,-6.822000026702881 C-7.941999912261963,-6.822000026702881 4.245999813079834,9.75100040435791 4.245999813079834,9.75100040435791 C4.245999813079834,9.75100040435791 4.313000202178955,9.720999717712402 4.313000202178955,9.720999717712402 C4.313000202178955,9.720999717712402 7.941999912261963,-9.75100040435791 7.941999912261963,-9.75100040435791 C7.941999912261963,-9.75100040435791 -7.941999912261963,-6.822000026702881 -7.941999912261963,-6.822000026702881z"
            ></path>
          </g>
          <g
            opacity="1"
            transform="matrix(1,0,0,1,37.44900131225586,30.350000381469727)"
          >
            <path
              fill="rgb(0,212,3)"
              fillOpacity="1"
              d=" M-13.229999542236328,8.413000106811523 C-13.229999542236328,8.413000106811523 13.229999542236328,8.15999984741211 13.229999542236328,8.15999984741211 C13.229999542236328,8.15999984741211 1.0410000085830688,-8.413000106811523 1.0410000085830688,-8.413000106811523 C1.0410000085830688,-8.413000106811523 -13.229999542236328,8.413000106811523 -13.229999542236328,8.413000106811523z"
            ></path>
          </g>
          <g
            opacity="1"
            transform="matrix(1,0,0,1,13.486000061035156,28.83799934387207)"
          >
            <path
              fill="rgb(8,252,2)"
              fillOpacity="1"
              d=" M-10.732999801635742,-1.0520000457763672 C-10.732999801635742,-1.0520000457763672 10.732999801635742,9.925000190734863 10.732999801635742,9.925000190734863 C10.732999801635742,9.925000190734863 8.807000160217285,-9.925000190734863 8.807000160217285,-9.925000190734863 C8.807000160217285,-9.925000190734863 -10.732999801635742,-1.0520000457763672 -10.732999801635742,-1.0520000457763672z"
            ></path>
          </g>
          <g
            opacity="1"
            transform="matrix(1,0,0,1,37.481998443603516,52.862998962402344)"
          >
            <path
              fill="rgb(8,252,2)"
              fillOpacity="1"
              d=" M13.196999549865723,-14.354000091552734 C13.196999549865723,-14.354000091552734 -13.262999534606934,-14.10099983215332 -13.262999534606934,-14.10099983215332 C-13.262999534606934,-14.10099983215332 0.5450000166893005,14.383000373840332 0.5450000166893005,14.383000373840332 C0.5450000166893005,14.383000373840332 13.196000099182129,-14.02299976348877 13.196000099182129,-14.02299976348877 C13.196000099182129,-14.02299976348877 13.262999534606934,-14.383000373840332 13.262999534606934,-14.383000373840332 C13.262999534606934,-14.383000373840332 13.196999549865723,-14.354000091552734 13.196999549865723,-14.354000091552734z"
            ></path>
          </g>
          <g
            opacity="1"
            transform="matrix(1,0,0,1,55.944000244140625,47.62099838256836)"
          >
            <path
              fill="rgb(1,153,2)"
              fillOpacity="1"
              d=" M-5.198999881744385,-9.142000198364258 C-5.198999881744385,-9.142000198364258 -5.265999794006348,-8.781000137329102 -5.265999794006348,-8.781000137329102 C-5.265999794006348,-8.781000137329102 -17.91699981689453,19.625999450683594 -17.91699981689453,19.625999450683594 C-17.91699981689453,19.625999450683594 17.91699981689453,-19.625999450683594 17.91699981689453,-19.625999450683594 C17.91699981689453,-19.625999450683594 -5.198999881744385,-9.142000198364258 -5.198999881744385,-9.142000198364258z"
            ></path>
          </g>
          <g
            opacity="1"
            transform="matrix(1,0,0,1,20.388999938964844,47.51599884033203)"
          >
            <path
              fill="rgb(1,226,0)"
              fillOpacity="1"
              d=" M-17.636999130249023,-19.729999542236328 C-17.636999130249023,-19.729999542236328 17.636999130249023,19.729999542236328 17.636999130249023,19.729999542236328 C17.636999130249023,19.729999542236328 3.8289999961853027,-8.753000259399414 3.8289999961853027,-8.753000259399414 C3.8289999961853027,-8.753000259399414 -17.636999130249023,-19.729999542236328 -17.636999130249023,-19.729999542236328z"
            ></path>
          </g>
          <g
            opacity="1"
            transform="matrix(1,0,0,1,38.35900115966797,12.345000267028809)"
          >
            <path
              fill="rgb(8,252,2)"
              fillOpacity="1"
              d=" M13.779000282287598,-7.117000102996826 C13.779000282287598,-7.117000102996826 -0.14399999380111694,-9.592000007629395 -0.14399999380111694,-9.592000007629395 C-0.14399999380111694,-9.592000007629395 -14.140999794006348,-7.117000102996826 -14.140999794006348,-7.117000102996826 C-14.140999794006348,-7.117000102996826 -24.97100067138672,-2.3889999389648438 -24.97100067138672,-2.3889999389648438 C-24.97100067138672,-2.3889999389648438 -19.09000015258789,3.5269999504089355 -19.09000015258789,3.5269999504089355 C-19.09000015258789,3.5269999504089355 -16.06599998474121,6.567999839782715 -16.06599998474121,6.567999839782715 C-16.06599998474121,6.567999839782715 -8.567999839782715,7.9670000076293945 -8.567999839782715,7.9670000076293945 C-8.567999839782715,7.9670000076293945 0.13199999928474426,9.592000007629395 0.13199999928474426,9.592000007629395 C0.13199999928474426,9.592000007629395 16.013999938964844,6.660999774932861 16.013999938964844,6.660999774932861 C16.013999938964844,6.660999774932861 24.97100067138672,-2.242000102996826 24.97100067138672,-2.242000102996826 C24.97100067138672,-2.242000102996826 13.779000282287598,-7.117000102996826 13.779000282287598,-7.117000102996826z"
            ></path>
          </g>
          <g
            opacity="1"
            transform="matrix(1,0,0,1,12.52299976348877,18.871000289916992)"
          >
            <path
              fill="rgb(86,252,126)"
              fillOpacity="1"
              d=" M6.747000217437744,-2.999000072479248 C6.747000217437744,-2.999000072479248 0.8659999966621399,-8.914999961853027 0.8659999966621399,-8.914999961853027 C0.8659999966621399,-8.914999961853027 -9.770000457763672,8.914999961853027 -9.770000457763672,8.914999961853027 C-9.770000457763672,8.914999961853027 9.770000457763672,0.041999999433755875 9.770000457763672,0.041999999433755875 C9.770000457763672,0.041999999433755875 6.747000217437744,-2.999000072479248 6.747000217437744,-2.999000072479248z"
            ></path>
          </g>
          <g
            opacity="1"
            transform="matrix(1,0,0,1,25.80299949645996,6.790999889373779)"
          >
            <path
              fill="rgb(86,252,126)"
              fillOpacity="1"
              d=" M-11.90999984741211,4.038000106811523 C-11.90999984741211,4.038000106811523 -1.437000036239624,-1.3650000095367432 -1.437000036239624,-1.3650000095367432 C-1.437000036239624,-1.3650000095367432 12.413000106811523,-4.038000106811523 12.413000106811523,-4.038000106811523 C12.413000106811523,-4.038000106811523 -1.5829999446868896,-1.562999963760376 -1.5829999446868896,-1.562999963760376 C-1.5829999446868896,-1.562999963760376 -12.413000106811523,3.1649999618530273 -12.413000106811523,3.1649999618530273 C-12.413000106811523,3.1649999618530273 -11.90999984741211,4.038000106811523 -11.90999984741211,4.038000106811523z"
            ></path>
          </g>
          <g
            opacity="1"
            transform="matrix(1,0,0,1,22.658000946044922,28.836999893188477)"
          >
            <path
              fill="rgb(86,252,126)"
              fillOpacity="1"
              d=" M-0.36500000953674316,-9.925000190734863 C-0.36500000953674316,-9.925000190734863 1.5609999895095825,9.925000190734863 1.5609999895095825,9.925000190734863 C1.5609999895095825,9.925000190734863 -1.5609999895095825,-9.788999557495117 -1.5609999895095825,-9.788999557495117 C-1.5609999895095825,-9.788999557495117 -0.36500000953674316,-9.925000190734863 -0.36500000953674316,-9.925000190734863z"
            ></path>
          </g>
          <g
            opacity="1"
            transform="matrix(1,0,0,1,30.391000747680664,20.697999954223633)"
          >
            <path
              fill="rgb(86,252,126)"
              fillOpacity="1"
              d=" M-8.097999572753906,-1.7860000133514404 C-8.097999572753906,-1.7860000133514404 8.097999572753906,1.2380000352859497 8.097999572753906,1.2380000352859497 C8.097999572753906,1.2380000352859497 7.635000228881836,1.7860000133514404 7.635000228881836,1.7860000133514404 C7.635000228881836,1.7860000133514404 -8.097999572753906,-1.7860000133514404 -8.097999572753906,-1.7860000133514404z"
            ></path>
          </g>
          <g
            opacity="1"
            transform="matrix(1,0,0,1,58.165000915527344,14.6899995803833)"
          >
            <path
              fill="rgb(86,252,126)"
              fillOpacity="1"
              d=" M5.164999961853027,-4.586999893188477 C5.164999961853027,-4.586999893188477 -5.164999961853027,4.586999893188477 -5.164999961853027,4.586999893188477 C-5.164999961853027,4.586999893188477 -3.7899999618530273,4.315999984741211 -3.7899999618530273,4.315999984741211 C-3.7899999618530273,4.315999984741211 5.164999961853027,-4.586999893188477 5.164999961853027,-4.586999893188477z"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const ExpolitionBombSvg = (props: SVGProps) => {
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 70 67"
      style={{ width: "96%" }}
      {...props}
    >
      <title>bomb</title>
      <path
        d="M35,70a35.47,35.47,0,0,1-8.45-1A35,35,0,1,1,49.83,3.3c3.53-2.25,8.75-.54,12.39,4.16.15.19.3.39.44.59a11.89,11.89,0,0,1,3.61,2.31,10.6,10.6,0,0,1,3.27,7.91A9,9,0,0,1,68,23.44a32.32,32.32,0,0,1,1.14,4h0A35,35,0,0,1,35,70ZM35,6.47A28.57,28.57,0,1,0,62.85,28.84h0A27.53,27.53,0,0,0,61.34,24a3.17,3.17,0,0,1-.16-2,3.2,3.2,0,0,1-1.49-1.33c-.29-.5-.6-1-.92-1.48a3.23,3.23,0,0,1-.11-3.39.92.92,0,0,0,.06-.29,3.33,3.33,0,0,1,.77-1.79,3.16,3.16,0,0,1-1.73-1.4,11.43,11.43,0,0,0-.65-.95c-1.59-2-3.35-2.68-3.87-2.62A1.81,1.81,0,0,1,53,9l-1.37.79a3.22,3.22,0,0,1-3.14.06A28.47,28.47,0,0,0,35,6.47Z"
        style={{ fill: "#051d27" }}
      />
      <path
        d="M66.76,35A31.62,31.62,0,0,0,66,28.14c-2.45-.61-13.43-3.53-16.07-3.53-17.55,0-28.75,14.48-28.75,32,0,2.35,5.65,7,6.14,9.19A31.8,31.8,0,0,0,66.76,35Z"
        style={{ fill: "#d8003e" }}
      />
      <path
        d="M58.34,27.2a31.72,31.72,0,0,1,7.67.94A31.76,31.76,0,1,0,27.33,65.83a31.77,31.77,0,0,1,31-38.63Z"
        style={{ fill: "#fd013e" }}
      />
      <path
        d="M51.33,6.19,45.71,9.44c-2.24,1.74-1.7,6.17,1.19,9.9S54,24.69,56.19,23l4.55-4.64Z"
        style={{ fill: "#d8003e" }}
      />
      <ellipse
        cx="56.03"
        cy="12.26"
        rx="4.6"
        ry="7.67"
        transform="translate(4.24 36.9) rotate(-37.78)"
        style={{ fill: "#fd013e" }}
      />
      <path
        d="M41.45,38.53a1.55,1.55,0,0,1-.37,0,1.84,1.84,0,0,1-1.44-2.17c2-9.64,10.07-12,16-13.71,4.86-1.41,7-2.24,7-4.34a3.76,3.76,0,0,0-1.11-2.89c-1.91-1.81-5.63-1.67-5.67-1.66a1.84,1.84,0,1,1-.2-3.68c.22,0,5.33-.25,8.41,2.67a7.43,7.43,0,0,1,2.26,5.56c0,5.08-4.9,6.5-9.65,7.88-5.85,1.69-11.9,3.45-13.41,10.9A1.85,1.85,0,0,1,41.45,38.53Z"
        style={{ fill: "#2a2f3c" }}
      />
      <polygon
        points="32.81 53.29 33.53 54.59 30.13 56.91 30.49 53.72 32.81 53.29"
        style={{ fill: "#fff" }}
      />
      <polygon
        points="20.47 56.89 20.73 57.24 19.67 57.76 19.72 56.95 20.47 56.89"
        style={{ fill: "#fff" }}
      />
      <polygon
        points="32.15 47.91 32.26 48.82 33.05 48.66 32.87 47.59 32.15 47.91"
        style={{ fill: "#fff" }}
      />
      <polygon
        points="35.28 46.02 34.89 47.73 36.14 47.94 36.82 46.87 36.39 45.91 35.28 46.02"
        style={{ fill: "#fff" }}
      />
      <polygon
        points="38.02 48.47 37.97 49.28 39.03 48.76 38.77 48.41 38.02 48.47"
        style={{ fill: "#fff" }}
      />
      <polygon
        points="41.13 49.33 42.21 48.85 42.71 50.93 41.48 51.1 41.13 49.33"
        style={{ fill: "#fff" }}
      />
      <polygon
        points="32.64 39.9 33.07 40.85 32.39 41.92 31.14 41.71 31.54 40 32.64 39.9"
        style={{ fill: "#fff" }}
      />
      <polygon
        points="44.43 45.41 44.62 46.48 43.83 46.65 43.71 45.74 44.43 45.41"
        style={{ fill: "#fff" }}
      />
      <polygon
        points="47.56 43.79 46.62 45.17 49.51 46.55 49.95 45.02 47.56 43.79"
        style={{ fill: "#fff" }}
      />
      <polygon
        points="52.47 47.67 52.42 48.48 53.48 47.96 53.22 47.61 52.47 47.67"
        style={{ fill: "#fff" }}
      />
      <polygon
        points="51.74 51.27 51.31 52.23 52.6 53.19 54.63 51.91 51.74 51.27"
        style={{ fill: "#fff" }}
      />
      <polygon
        points="51.63 58.46 50.91 58.78 51.02 59.69 51.82 59.53 51.63 58.46"
        style={{ fill: "#fff" }}
      />
      <polygon
        points="46.62 39.13 46.86 36.72 48.76 36.45 49.38 37.45 46.62 39.13"
        style={{ fill: "#fff" }}
      />
      <polygon
        points="61.89 33.9 61.84 34.71 62.9 34.19 62.64 33.84 61.89 33.9"
        style={{ fill: "#fff" }}
      />
      <polygon
        points="47.15 33.15 47.73 33.71 47.01 34.52 46.57 33.86 47.15 33.15"
        style={{ fill: "#fff" }}
      />
      <polygon
        points="36.75 33.83 35.69 34.34 35.73 33.53 36.48 33.47 36.75 33.83"
        style={{ fill: "#fff" }}
      />
      <polygon
        points="35.78 37.44 35.05 37.77 35.17 38.67 35.96 38.51 35.78 37.44"
        style={{ fill: "#fff" }}
      />
      <polygon
        points="33.78 34.62 33 35.77 31.73 35.41 31.25 33.9 32.46 32.87 33.78 34.62"
        style={{ fill: "#fff" }}
      />
      <polygon
        points="28.58 24.4 28.76 25.46 27.97 25.63 27.85 24.72 28.58 24.4"
        style={{ fill: "#fff" }}
      />
      <polygon
        points="47 26.82 43.8 40.43 34.23 26.82 41.68 41.48 31.04 38.34 37.42 42.53 19.33 47.76 39.55 44.62 36.36 55.09 42.74 47.76 47 51.95 47 46.72 61.89 49.86 48.06 43.57 55.51 38.34 47 41.48 47 26.82"
        style={{ fill: "#fdcb02" }}
      />
      <polygon
        points="56.57 43.61 63.67 41.84 63.67 43.61 56.57 43.61"
        style={{ fill: "#fdcb02" }}
      />
      <polygon
        points="32.63 33.01 26.43 22.4 25.54 25.05 32.63 33.01"
        style={{ fill: "#fdcb02" }}
      />
      <polygon
        points="34.41 52.44 28.2 63.04 27.31 60.39 34.41 52.44"
        style={{ fill: "#fdcb02" }}
      />
      <polygon
        points="46.93 44.58 52.19 51.23 44.6 47 42.26 52.44 41.09 48.21 33.1 50.41 38.17 44.58 32.92 42.16 38.17 40.35 36.42 37.94 41.09 38.54 39.92 29.47 43.43 38.54 44.6 37.94 44.6 39.75 49.85 37.33 46.93 42.16 53.36 42.77 46.93 44.58"
        style={{ fill: "#fff" }}
      />
    </svg>
  );
};

export const EthSvg = (props: SVGProps) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 96 96"
      style={{
        width: "100%",
      }}
      {...props}
    >
      <path
        d="M96 48c0 26.51-21.49 48-48 48S0 74.51 0 48 21.49 0 48 0s48 21.49 48 48Z"
        fill="#627EEA"
      ></path>
      <path
        opacity=".6"
        d="M49.5 12v26.61L72 48.66 49.5 12Z"
        fill="#fff"
      ></path>
      <path d="M49.5 12 27 48.66l22.5-10.05V12Z" fill="#fff"></path>
      <path
        opacity=".6"
        d="M49.5 65.91V84L72 52.845 49.5 65.91Z"
        fill="#fff"
      ></path>
      <path d="M49.5 84V65.895L27 52.845 49.5 84Z" fill="#fff"></path>
      <path
        opacity=".2"
        d="M49.5 61.725 72 48.66 49.5 38.61v23.115Z"
        fill="#fff"
      ></path>
      <path
        opacity=".6"
        d="m27 48.66 22.5 13.065V38.61L27 48.66Z"
        fill="#fff"
      ></path>
    </svg>
  );
};

export const InfinitySvg = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    fill="#fcfcfc"
    stroke="#fcfcfc"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <style type="text/css">{".st0{fill:#ffffff;}"}</style>
      <g>
        <path
          className="st0"
          d="M501.98,206.15c-9.769-23.023-25.998-42.56-46.458-56.389c-10.181-6.873-21.446-12.34-33.536-16.068 c-12.009-3.809-24.842-5.798-38.088-5.798c-16.982,0-33.294,3.316-48.197,9.365c-1.246,0.492-2.402,0.986-3.558,1.568 c-13.416,5.879-25.675,14.16-36.188,24.017c-3.396,3.227-6.623,6.623-9.858,10.432c-5.709,6.542-11.588,14.079-17.305,21.696 c-1.157,1.568-2.402,3.226-3.558,4.804c-3.146,4.302-33.212,48.358-38.509,56.226c-2.652,3.97-5.798,8.442-9.195,13.327 c-0.744,1.076-1.568,2.24-2.393,3.396c-5.636,8.031-11.928,16.481-17.726,23.937c-2.895,3.72-5.798,7.197-8.281,10.1 c-2.563,2.976-4.884,5.378-6.542,6.954c-7.116,6.704-15.486,12.171-24.672,15.899c-9.194,3.728-19.214,5.798-29.816,5.798 c-7.286,0-14.322-0.996-20.944-2.815c-3.396-0.913-6.712-2.07-9.939-3.477c-14.248-5.968-26.419-16.068-34.95-28.74 c-4.302-6.372-7.699-13.327-10.019-20.783c-2.233-7.456-3.558-15.316-3.558-23.597c0-11.014,2.24-21.365,6.21-30.892 c6.049-14.24,16.149-26.329,28.821-34.942c6.372-4.31,13.326-7.618,20.782-9.939c7.448-2.321,15.316-3.638,23.597-3.638 c10.602,0.08,20.622,2.07,29.816,5.79c9.187,3.808,17.556,9.194,24.672,15.898c1.658,1.577,3.979,4.059,6.542,6.962 c4.472,5.216,9.769,11.92,15.074,18.964c2.07,2.814,4.14,5.628,6.21,8.523c7.949-11.588,21.858-31.959,29.144-42.48 c-1.237-1.658-2.482-3.307-3.72-4.965c-3.316-4.23-6.631-8.281-9.938-12.009c-3.316-3.809-6.462-7.205-9.858-10.432 c-11.426-10.772-24.922-19.545-39.746-25.586c-14.904-6.049-31.222-9.365-48.196-9.365c-17.637,0-34.53,3.566-49.927,10.108 c-23.022,9.688-42.487,25.918-56.316,46.369c-6.873,10.19-12.332,21.527-16.141,33.536C1.989,229.997,0,242.75,0,256.004 c0,17.637,3.558,34.53,10.02,49.846c9.768,23.104,25.998,42.569,46.369,56.397c10.27,6.874,21.535,12.332,33.624,16.141 c12.008,3.728,24.842,5.717,38.088,5.717c16.974,0,33.293-3.316,48.196-9.356c14.824-6.049,28.239-14.824,39.666-25.506l0.08-0.081 c3.397-3.146,6.543-6.631,9.858-10.44c5.709-6.542,11.588-14.071,17.305-21.689c1.157-1.577,2.402-3.154,3.558-4.723 c3.146-4.391,44.307-64.758,47.696-69.642c0.752-1.076,1.577-2.232,2.401-3.396c5.637-7.95,11.928-16.48,17.726-23.928 c2.895-3.728,5.798-7.206,8.281-10.101c2.564-2.984,4.885-5.386,6.542-6.962c7.116-6.704,15.486-12.09,24.673-15.898 c2.24-0.906,4.472-1.649,6.792-2.402c7.286-2.15,14.984-3.307,23.023-3.388c11.013,0.08,21.446,2.232,30.882,6.291 c14.241,5.96,26.42,16.06,34.943,28.732c4.31,6.38,7.706,13.335,10.019,20.782c2.321,7.456,3.566,15.324,3.566,23.605 c0,11.014-2.24,21.446-6.21,30.883c-6.049,14.24-16.149,26.419-28.821,34.942c-6.372,4.31-13.326,7.707-20.782,9.939 c-7.367,2.321-15.316,3.648-23.597,3.648c-10.602,0-20.622-2.07-29.816-5.798c-9.187-3.728-17.557-9.195-24.673-15.899 c-1.658-1.577-3.979-4.059-6.542-6.954c-4.472-5.135-9.776-11.928-15.074-18.963c-2.15-2.815-4.221-5.718-6.291-8.613 c-0.663,0.994-1.326,1.99-2.07,3.065c-13.666,20.039-22.279,32.71-26.994,39.576c1.237,1.658,2.483,3.235,3.72,4.893 c3.316,4.221,6.631,8.281,9.938,12c3.234,3.808,6.462,7.294,9.858,10.44c11.426,10.763,24.923,19.538,39.746,25.587 c14.904,6.04,31.215,9.356,48.197,9.356c17.636,0,34.53-3.558,49.846-10.019c23.103-9.769,42.56-25.999,56.396-46.458 c6.866-10.181,12.421-21.446,16.141-33.536C510.01,282.083,512,269.25,512,256.004C512,238.367,508.442,221.474,501.98,206.15z"
        ></path>
      </g>
    </g>
  </svg>
);

export const PercentSvg = (props: SVGProps) => {
  return (
    <svg viewBox="0 0 64 64" className="svg-icon" fill="#fcfcfc" {...props}>
      <path d="M18.38 29.904c6.364 0 11.524-5.16 11.524-11.524 0-6.364-5.16-11.524-11.524-11.524-6.364 0-11.525 5.16-11.525 11.524 0 6.364 5.16 11.524 11.524 11.524Zm0-14.666a3.142 3.142 0 1 1-.001 6.285 3.142 3.142 0 0 1 0-6.285Zm27.24 18.858c-6.364 0-11.524 5.16-11.524 11.524 0 6.364 5.16 11.524 11.524 11.524 6.364 0 11.524-5.16 11.524-11.524 0-6.364-5.16-11.524-11.524-11.524Zm0 14.666a3.142 3.142 0 1 1 0-6.285 3.142 3.142 0 0 1 0 6.285Zm.585-41.904L6.857 57.144h10.644L56.85 6.858H46.205Z"></path>
    </svg>
  );
};


export const Forward = (props: SVGProps) => {
  return (
    <svg viewBox="0 0 64 64" {...props} > <title></title> <path fillRule="evenodd" clipRule="evenodd" d="m0 49.74 7.793 7.794L33.328 32 7.793 6.466 0 14.259 17.74 32 0 49.74Zm30.672 0 7.793 7.794L64 32 38.465 6.466l-7.793 7.793L48.412 32 30.673 49.74Z"></path></svg>
  )
}

export const Upward = (props: SVGProps) => {
  return (
    <svg viewBox="0 0 64 64" {...props}><path d="M32.271 17 9.201 40.071 16.128 47l16.145-16.145L48.418 47l6.93-6.929L32.275 17h-.005Z"></path></svg>
  )
}

export const UpwardZ = (props: SVGProps) => {
  return (
    <svg viewBox="0 0 64 64" {...props}><path d="m32 47.377 24-24 8 8-32 32-32-32 8-8 24 24ZM.322.621h63.356v11.313H.322V.622Z"></path></svg>
  )
}

export const Same = (props: SVGProps) => {
  return <svg viewBox="0 0 64 64" style={{ color: "#7F47FD" }}><path d="M0 15.365h64v11.428H0V15.365Zm0 21.842h64v11.428H0V37.207Z"></path></svg>
}


export const CopyIcon = () => {
  return <svg fill="white" viewBox="0 0 64 64" > <title></title> <path d="M61.334 64H16V12.986h45.334V64ZM2.666 0v45.466H9.28V6.506h38.96V0H2.666Z"></path></svg>
}


export const BallIcon = () => {
  return <svg version="1.1" viewBox="0 0 32 32" fill="#000000"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g>  <g> <circle fill="#FFFAEE" cx="16" cy="16" r="13.5"></circle> <g> <g> <path fill="#DBD2C1" d="M16,2.5C8.544,2.5,2.5,8.544,2.5,16c0,7.456,6.044,13.5,13.5,13.5S29.5,23.456,29.5,16 C29.5,8.544,23.456,2.5,16,2.5z M16,28C9.383,28,4,22.617,4,16S9.383,4,16,4s12,5.383,12,12S22.617,28,16,28z"></path> </g> </g> <g> <g> <path fill="#3D3935" d="M2.987,16.802L2.533,16.65C2.522,16.433,2.5,16.22,2.5,16c0-2.536,0.712-4.9,1.928-6.927 l0.473,0.158l1.542,3.824L2.987,16.802z M10.621,28.379L11,28l-1-4l-5-1l-0.328,0.328C6.109,25.545,8.174,27.314,10.621,28.379z M27.099,9.231l-1.542,3.824l3.457,3.748l0.453-0.152C29.478,16.434,29.5,16.22,29.5,16c0-2.536-0.712-4.9-1.928-6.927 L27.099,9.231z M21.419,14.214L16,10.601l-5.419,3.613l1.796,6.286h7.246L21.419,14.214z M27.328,23.328L27,23l-5,1l-1,4 l0.379,0.379C23.826,27.314,25.891,25.545,27.328,23.328z M21,4V3.468C19.452,2.85,17.768,2.5,16,2.5s-3.452,0.35-5,0.968V4l5,2 L21,4z"></path> </g> </g> <path fill="#231F20" d="M16,2C8.268,2,2,8.268,2,16s6.268,14,14,14s14-6.268,14-14S23.732,2,16,2z M28.998,16.048 l-2.859-3.1l1.275-3.164C28.424,11.632,29,13.75,29,16C29,16.016,28.998,16.032,28.998,16.048z M20.293,3.744L16,5.462 l-4.293-1.718C13.053,3.271,14.494,3,16,3S18.947,3.271,20.293,3.744z M4.586,9.784l1.276,3.164l-2.86,3.1 C3.002,16.032,3,16.016,3,16C3,13.75,3.576,11.632,4.586,9.784z M5.48,23.606l4.112,0.823l0.823,3.292 C8.445,26.778,6.75,25.359,5.48,23.606z M11.567,28.205l-1.158-4.634l-5.689-1.137c-0.863-1.506-1.436-3.196-1.635-5l3.943-4.273 l-1.792-4.44c1.287-1.898,3.07-3.426,5.151-4.428L16,6.538l5.614-2.245c2.082,1.003,3.864,2.531,5.151,4.429l-1.791,4.44 l3.942,4.273c-0.199,1.804-0.773,3.494-1.635,5l-5.689,1.137l-1.158,4.634C19.047,28.71,17.559,29,16,29 S12.953,28.71,11.567,28.205z M21.586,27.721l0.823-3.292l4.112-0.823C25.25,25.359,23.555,26.778,21.586,27.721z M22,14l-6-4l-6,4 l2,7h8L22,14z M12.754,20l-1.592-5.573L16,11.202l4.838,3.225L19.246,20H12.754z"></path> </g> </g></svg>
}

export const AudioIcon = () => {
  return <svg viewBox="0 0 64 64">
    <path fillRule="evenodd" clipRule="evenodd"
      d="M0 20.8v22.4h16L35.2 56V8L16 20.8H0ZM41.6 9.6v8C49.552 17.6 56 24.048 56 32s-6.448 14.4-14.4 14.4v8C53.972 54.4 64 44.372 64 32 64 19.628 53.972 9.6 41.6 9.6ZM41.574 24a8 8 0 0 1 0 16V24Z"></path>
  </svg>
}

export const AnimationIcon = () => {
  return <svg viewBox="0 0 64 64">
    <path
      d="M29.176 20.932c-1.778 3.154-2.824 6.922-2.824 10.936s1.048 7.784 2.882 11.05l-.058-.114c-.844.23-1.816.366-2.818.376h-.006c-6.238 0-11.294-5.056-11.294-11.294s5.056-11.294 11.294-11.294h.04c.988 0 1.948.124 2.864.356l-.08-.018v.002ZM9.036 24.47c-.958 2.182-1.514 4.724-1.514 7.398 0 2.674.558 5.216 1.562 7.518l-.048-.122a10.297 10.297 0 0 1-1.54-.002l.034.002a7.53 7.53 0 0 1 0-15.06c.566.056 1.078.15 1.576.28l-.07-.016v.002Zm39.906 22.588c-8.316 0-15.058-6.742-15.058-15.058 0-8.316 6.742-15.058 15.058-15.058C57.258 16.942 64 23.684 64 32c-.064 8.216-6.696 14.862-14.9 14.946h-.008l-.15.112Z"></path>
  </svg>
}

export const MaxBetIcon = () => {
  return <svg viewBox="0 0 64 64">
    <path
      d="M7.36 42.39c1-12.78 14.728-25.29 17.926-29.976 2.778-4.206 1.719-9.203.83-11.4a.78.78 0 0 1 .893-1h-.004c13.889 2.918 14.588 13.48 14.168 18.206-.42 4.726.42 7.913 3.478 7.224 3.057-.69 2.028-8.443 2.028-8.443s14.039 16.676 8.893 33.073c-2.588 8.574-9.033 12.19-14.449 13.89-.28.14-.56-.14-.56-.55.7-2.638 2.509-4.726 3.058-7.644 1.12-4.796-3.327-9.213-6.624-11.71-2.063-1.538-3.386-3.97-3.386-6.712 0-.127.002-.255.008-.381v.018c0-.28-.42-.42-.55-.28a90.106 90.106 0 0 1-6.652 7.202l-.022.022c-5.136 5.696-7.784 12.09-3.197 19.175.14.28-.14.69-.41.56C11.387 60.596 6.67 51.973 7.36 42.39Z"></path>
  </svg>
}

export const GameInfoIcon = () => {
  return <svg viewBox="0 0 64 64">
    <title></title>
    <path fillRule="evenodd" clipRule="evenodd"
      d="M22.8 8.547h36.774c0 .028.026.054.026.054h-.016a6.75 6.75 0 0 0-6.384 6.586v33.04l-.002-.02a6.8 6.8 0 0 1-6.786 7.246 6.8 6.8 0 0 1-6.786-7.226v-3.094H16V15.347a6.8 6.8 0 0 1 6.8-6.8Zm-.828 27.894h15.494V31.8H21.972v4.64Zm.002-12.4h24.8V19.4h-24.8v4.64Zm38.052-13.574h-.052A3.974 3.974 0 0 0 56 14.44v6.426h8V14.44a3.974 3.974 0 0 0-3.974-3.974ZM36.8 48.256H0a6.8 6.8 0 0 0 6.8 6.8h34.026c-2.694 0-4.026-3.04-4.026-6.8Z"></path>
  </svg>
}

export const KeyBoardIcon = () => {
  return <svg viewBox="0 0 64 64">
    <path
      d="M61.14 10.668H2.852A2.85 2.85 0 0 0 0 13.518v37.146a2.667 2.667 0 0 0 2.668 2.668h58.664A2.667 2.667 0 0 0 64 50.665V13.519a2.85 2.85 0 0 0-2.852-2.851h-.008ZM35.086 17.81h6.187v5.332h-6.187V17.81Zm0 11.495h6.187v5.332h-6.187v-5.332ZM22.715 17.811h6.187v5.332h-6.187V17.81Zm0 11.495h6.187v5.332h-6.187v-5.332ZM10.367 17.811h6.188v5.332h-6.188V17.81Zm0 11.495h6.188v5.332h-6.188v-5.332Zm43.254 16.88H10.37v-5.332h43.25v5.331Zm0-11.496h-6.188v-5.36h6.188v5.36Zm0-11.463h-6.188v-5.332h6.188v5.332Z"></path>
  </svg>
}

export const SettingIcon = () => {
  return <svg viewBox="0 0 64 64">
    <path
      d="M55.441 32a26.082 26.082 0 0 0-.34-3.99l.02.15 8.16-6-7.12-12.32-9.254 4.054a23.83 23.83 0 0 0-6.502-3.784l-.164-.056L39.121 0h-14.24l-1.12 10.054c-2.554.98-4.76 2.276-6.71 3.874l.042-.034L7.84 9.84.72 22.16l8.16 6a25.007 25.007 0 0 0-.32 3.828V32c.012 1.366.128 2.694.34 3.99l-.02-.15-8.16 6 7.12 12.32 9.254-4.054a23.83 23.83 0 0 0 6.502 3.784l.164.056L24.88 64h14.24l1.12-10.054c2.554-.98 4.76-2.276 6.71-3.874l-.042.034 9.254 4.054 7.12-12.32-8.16-6c.192-1.146.308-2.474.32-3.828V32Zm-23.44 8.666A8.666 8.666 0 1 1 40.667 32c-.016 4.78-3.886 8.652-8.666 8.666H32h.002Z"></path>
  </svg>
}

export const LowerSvgIcon = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 16" className="w-[12px] rotate-180" fill="#2AB2E9"><path d="M4.4864 13.667C3.92507 13.667 3.4701 13.3014 3.4701 12.8494L3.47099 7.54931L1.18095 7.54931C0.306767 7.54931 -0.251889 6.81602 0.113696 6.19768L0.160176 6.127L3.9787 0.807585C4.43188 0.175683 5.56796 0.175683 6.02204 0.807585L9.84056 6.127C10.2937 6.7589 9.72704 7.54931 8.81889 7.54931L6.52974 7.54931L6.52974 12.8494C6.52974 13.3014 6.07477 13.667 5.51344 13.667L4.48819 13.667L4.4864 13.667Z"></path></svg>
}

export const HigherSvgIcon = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 16" className="w-[12px]" fill="#EECF2D"><path d="M4.4864 13.667C3.92507 13.667 3.4701 13.3014 3.4701 12.8494L3.47099 7.54931L1.18095 7.54931C0.306767 7.54931 -0.251889 6.81602 0.113696 6.19768L0.160176 6.127L3.9787 0.807585C4.43188 0.175683 5.56796 0.175683 6.02204 0.807585L9.84056 6.127C10.2937 6.7589 9.72704 7.54931 8.81889 7.54931L6.52974 7.54931L6.52974 12.8494C6.52974 13.3014 6.07477 13.667 5.51344 13.667L4.48819 13.667L4.4864 13.667Z"></path></svg>
}
